import React from 'react';
import SMStorage from 'lib/SMStorage';

class SMToDoListView extends React.Component {
  
  toDoMessageDidSelect(){
    const cacheKey = sprintf("notifications-%s", this.props.currentUser.username);
    SMStorage.removeSessionItem(cacheKey);
  }
  
  render() {
    if (!this.props.notifications || !this.props.notifications.length) {
      return null;
    }
    let rows = [];
    for (let rowIndex = 0; rowIndex < this.props.notifications.length; rowIndex++) {
      
      const todo = this.props.notifications[rowIndex];
      const className = "is-new site-header__nav-baloon-menu clearfix";
      
      rows.push(
        <li className={className} key={rowIndex}>
          <a onClick={this.toDoMessageDidSelect.bind(this)} href={todo.link} data-tag={rowIndex} className="link-black link-borderless">
            <p className="site-header__nav-baloon-message-content">{todo.content}</p>
          </a>
        </li>
      );
    }
    return (
      <div>
        <h2 key="title" className="site-header__nav-baloon-title">やることリスト</h2>
        <ul>{rows}</ul>
      </div>
    );
  }
  
}
export default SMToDoListView;



// WEBPACK FOOTER //
// ./app/javascript/components/notifications/SMToDoListView.jsx